import { render, staticRenderFns } from "./ContragentEdit.vue?vue&type=template&id=45b625ff&"
import script from "./ContragentEdit.vue?vue&type=script&lang=js&"
export * from "./ContragentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContragentEdit.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports